import {observable, action} from 'mobx'
import {getAppList} from "@/services/abnormalMsg";
import GlobalStore from "@/store/GlobalStore";

class EquipmentListStore {
    @observable list = [] // 应用列表
    @observable maxMonitorCount = 0 // 最多监控数量
    @observable toast = GlobalStore.toast

    @action.bound
    async getAppList() {
        getAppList().then(res => {
            if (res.code === 10000) {
                this.list = (res.result && res.result.deviceList) || []
                this.maxMonitorCount = res.result && res.result.maxMonitorCount
            }
        }).catch(() => {
            this.toast.text(`当前网络不可用，请检查网络`)
        })
    }

}
export default new EquipmentListStore()
